<div fxLayout="column" ngClass.desktop="pl-56 pr-56 pt-48 pb-48 shadow-content" ngClass.mobile="pt-24 pl-16 pr-16 w-100"
     fxFlexAlign="center" fxLayoutAlign="center center">
    <ui-kit-svg [name]="icon" class="i-80"></ui-kit-svg>
    <div class="h3-semi-bold text-center c-primary-gray-900 mt-40 pre-line">
        {{ title | translate }}
    </div>
    <div class="t2 text-center c-primary-gray-900 mt-40 pre-line">
        {{ description | translate: additionalParams }}
    </div>
    <ui-kit-button class="mt-32"
                   [label]="'i18n_auth_goToCabinet' | translate"
                   type="secondary"
                   (clickListener)="onGoToCabinet()"
    ></ui-kit-button>
</div>
